import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NgbModalModule, NgbModule, NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {NgMultiSelectDropDownModule} from "../../LibrerieCustom/MultiselectDropdown";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule, Routes} from "@angular/router";
import {SharedModule} from "../shared/Shared.module";
import {TranslateModule} from "@ngx-translate/core";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {SerialiListComponent} from "./seriali-list/seriali-list.component";
import { SerialeComponent } from "./seriale/seriale.component";
const routes: Routes = [
  {
    path: 'list/:type',
    data: {
      title: "Infrastrutture",
      urls: [{ title: "List"}],
    },
    component: SerialiListComponent,
  },
]
@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    NgMultiSelectDropDownModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    RouterModule.forChild(routes),
    NgbPaginationModule,
    SharedModule,
    TranslateModule,
    DragDropModule,
  ],
  exports: [
  ],
  declarations: [
   SerialiListComponent,
   SerialeComponent
  ]
})
export class SerialiModule { }
